import { useRef } from "react";
import { Modal, Group, Text, Badge, Button, Stack, Loader } from "@mantine/core";
import { useGetFunctionsPingQuery } from "../openapi";

type Props = { onClose: () => void };

export default function HealthModal({ onClose }: Props) {
  // (Optional timing scaffold kept for future use; not shown in UI)
  const startedAt = useRef<number | null>(null);

  const { data, isFetching, isLoading, isSuccess, isError, refetch } =
    useGetFunctionsPingQuery(undefined);

  return (
    <Modal opened onClose={onClose} title="Systemstatus" size="lg">
      <Stack gap="sm">
        <Group justify="space-between">
          <Text fw={500}>Azure Functions Ping</Text>
          {isLoading || isFetching ? (
            <Badge color="blue" variant="light">
              Laddar...
            </Badge>
          ) : isSuccess ? (
            <Badge color="green" variant="light">
              OK
            </Badge>
          ) : (
            <Badge color="red" variant="light">
              Fel
            </Badge>
          )}
        </Group>

        <Text>
          {isLoading || isFetching ? (
            <Loader size="sm" />
          ) : isSuccess && data?.message ? (
            `Svar: ${data.message}`
          ) : (
            "Kunde inte hämta status. Försök igen."
          )}
        </Text>

        <Group justify="flex-end">
          <Button variant="outline" onClick={() => refetch()} disabled={isLoading || isFetching}>
            Testa igen
          </Button>
          <Button variant="neutral" onClick={onClose}>Lukk</Button>
        </Group>
      </Stack>
    </Modal>
  );
}
